exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sv-video-container {\n  position: absolute;\n  color: #c0c0c0;\n  border: 1px solid #c0c0c0;\n}\n.in-main {\n  z-index: 2;\n}\n.in-preview {\n  z-index: 3;\n}\n.in-quick-preview {\n  z-index: 4;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sergeisidorov/Projects/streamViewer/src/app/components/video-container.component/video-container.component.styl
// module id = ../../../../../src/app/components/video-container.component/video-container.component.styl
// module chunks = main